import { AlertProps } from "@material-ui/lab";
import { useEffect, useReducer } from "react";
import toast from "react-hot-toast";

type MessageAndSeverity = {
  message: string | null;
  severity: AlertProps["severity"];
};

type SetAction = {
  type: "set";
  payload: MessageAndSeverity;
};

type ClearAction = {
  type: "clear";
};

type MessageAndSeverityActions = SetAction | ClearAction;

const messageAndSeverityReducer = (
  state: MessageAndSeverity,
  action: MessageAndSeverityActions,
) => {
  switch (action.type) {
    case "set":
      return {
        ...state,
        message: action.payload.message,
        severity: action.payload.severity,
      };
    case "clear":
      return {
        ...state,
        message: null,
        severity: "info" as AlertProps["severity"],
      };
  }
};

export const useMessageAndSeverity = () => {
  const [state, dispatch] = useReducer(messageAndSeverityReducer, {
    message: null,
    severity: "info",
  });

  const setInfo = (message: string) =>
    dispatch({ type: "set", payload: { severity: "info", message } });
  const setError = (message: string) =>
    dispatch({ type: "set", payload: { severity: "error", message } });
  const clearMessage = () => dispatch({ type: "clear" });

  const { message, severity } = state;

  useEffect(() => {
    if (message) {
      switch (severity) {
        case "error":
        case "warning":
          toast.error(message);
          break;
        case "info":
        case "success":
        default:
          toast.success(message);
          break;
      }
    }
  }, [message, severity]);

  return { message, severity, setInfo, setError, clearMessage };
};

export default useMessageAndSeverity;
